<template>
  <div>
    <div class="pipeline-background">
      <NEWPipelineComponent :statuses="otherStatuses" />
      <NEWPipelineComponent :statuses="statusAll" />
    </div>
    <CommissioningOverviewTable />
  </div>
</template>

<script>
import { NEWPipelineComponent } from '@newnetzportal/netzportal-webapp-storybook-components';
import CommissioningOverviewTable from './CommissioningOverviewTable.vue';
import { getCommissioningTableConfig } from './commissioningTableConfig';
import { getCommissioningPipelineSummary } from '../../services/CommissioningService';
import { getCommissioningPipelineStatusAmount } from '../../helpers/commissioningStatuses';

export default {
  name: 'CommissioningOverviewComponent',
  components: {
    CommissioningOverviewTable,
    NEWPipelineComponent,
  },
  created() {
    this.getOrdersSummaryForPipeline();
  },
  data() {
    return {
      pipelineSummary: {},
      countOrderStatuses: getCommissioningTableConfig('countOrderStatuses'),
    };
  },
  computed: {
    journeyFilter() {
      return this.$store.getters.getJourneyFilter;
    },
    groupedStatusAmounts() {
      return this.countOrderStatuses.map((status) => ({
        ...status,
        amount: getCommissioningPipelineStatusAmount(
          this.pipelineSummary,
          status
        ),
      }));
    },
    groupedStatusesTotal() {
      return this.groupedStatusAmounts.reduce(
        (count, status) => count + status.amount,
        0
      );
    },
    statusAll() {
      return [
        {
          name: 'alle',
          color: '#999999',
          amount: this.pipelineTotal,
          percentage: 100,
        },
      ];
    },
    pipelineTotal() {
      return (
        Number(this.pipelineSummary.count_orders) || this.groupedStatusesTotal
      );
    },
    otherStatuses() {
      return this.groupedStatusAmounts.map((status) => ({
        name: status.label,
        color: status.color,
        amount: status.amount,
        percentage: this.pipelineTotal
          ? (status.amount / this.pipelineTotal) * 100
          : 0,
      }));
    },
  },
  watch: {
    journeyFilter() {
      this.getOrdersSummaryForPipeline();
    },
  },
  methods: {
    async getOrdersSummaryForPipeline() {
      const journey =
        this.journeyFilter && this.journeyFilter !== 'all'
          ? this.journeyFilter
          : '';

      try {
        this.pipelineSummary =
          (await getCommissioningPipelineSummary(journey)) || {};
      } catch (err) {
        console.error('Error fetching commissioning pipeline summary:', err);
        this.pipelineSummary = {};
      }
    },
  },
};
</script>
